import React from "react";

const Mission = () => {
  return (
    <div className="flex flex-col justify-center gap-4 xl:gap-10 xl:mx-24 mt-10">
      <div className="p-6 xl:p-[48px_100px] justify-between items-center bg-white rounded-[24px]  text-justify">
        <h3 className="text-[#493ED3] font-noto-sans-armenian text-[24px] text-center font-semibold leading-normal">
          ԱԶԳԱՅԻՆ ԴՊՐՈՑ
        </h3>
        <h3 className="text-[#493ED3] font-noto-sans-armenian text-[24px] text-center font-semibold leading-normal mb-4">
          Մեր մասին
        </h3>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Չինական հին իմաստությունն ասում է․ «Եթե մեկ տարվա ծրագիր ես կազմում,
          ապա ցորեն (բրինձ) ցանիր, եթե հինգ տավրա, ապա ծառ տնկիր, իսկ եթե
          տասնամյակների, հարյուրամյակների, ապա սերունդ կրթիր»։ Իսկ մեկ այլ հին
          ռազմավարություն հստակ սահմանում է․ «Եթե ուզում ես նվաճել որևէ
          հասարկություն, ապա բարոյալքիր նրա երիտասարդությանը»։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Եվ հիմա այս երկու ռազմավարությունների համատեքստում, Մենք այսօր պետք է
          հասկանանք, թե՞ որի ազդեցության տակ են գտնվում և ի՞նչ ընտրություն ենք
          կատարում։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Իսկ Մենք կատարել ենք մեր Ճշմարիտ ընտրությունը և, չեզոքացնելու համար
          երկրորդ՝ ապազգային ու հակապետական դավադիր ծրագիր/երը, ընտրել ենք
          սեփական Ազգային Համակարգերի կայացման ռազմավարությունը, որն ինքնին
          ենթադրում ու պարտադրում է Ազգային Կրթակարգի անհրաժեշտություն ու
          առկայություն, որն էլ իր իրացվելիության համար է ենթադրում ու պարտադրում
          Ազգային Դպրոցի առկայություն։ /թեկուզև, առայժմ թվային տեխնոլոգիաների
          ձևաչափով, առավել ևս, որ այսօր այդ թվային վիրտուալ հարթակները ոչ պակաս
          արդյունավետությամբ կարող են իրականացնել կրթության գործընթացը/։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Այս նպատակով ու առաքելությամբ էլ ստեղծվել է{" "}
          <strong className="text-[#493ED3]">«Ազգային Դպրոցը»</strong> հարթակը,
          տեխնոլոգիական գործիքը, որն իր մեջ ներգրավվում է, կարելի է ասել,
          հասարակության բոլոր շերտերին, որոնք մեքենայորեն դառնում են այս հարթակի
          շահառուները։
        </p>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          Այս իմաստով պայմանակնորեն կարելի է բաժանել երկու տիպի շահառուների՝{" "}
        </p>
        <ul className="ml-4 list-disc pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>ակտիվ</li>
          <li>պասիվ</li>
        </ul>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          Ակտիվ շահառուներն են՝
        </p>
        <ul className="ml-4 list-disc pl-5 text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <li>
            նրանք ովքեր իրենց ստեղծարար համագործակցությամբ ստեղծելու, արարելու
            են <strong className="text-[#493ED3]">«Ազգային Դպրոցը»</strong>{" "}
            բովանդակությունը՝ կոնտենտը, այսինք՝ դասախոսներ, ուսուցիչներ,
            ուսանողներ, աշակերտներ, գիտության, կրթության և մանկավարժության
            ոլորտի մասնագետներ և այլն։
          </li>
          <li>
            նրանք ովքեր օգտվելու, սպառելու են այդ բովանդակությունը, արդյունքը,
            «արտադրանքը», այսինքն՝ նույն դասախոսները, ուսուցիչները, ուսանողներն
            ու աշակերտները և այլք, ովքեր իրենց դասավանդման և դասապատրաստման
            համար օգտվելու են դպրոցի «հարստությունից»։
          </li>
        </ul>
        <p className="text-black font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <strong className="text-[#493ED3]">Եվ երկրորդը՝</strong> պասիվ
          շահառուները, որոնք ոչ պակաս կարևոր հանրային շերտ են ներկայացնում, որն
          իր թվաքանակով ավելի մեծ է ու բազմաշերտ։ Ամենից առաջ ի նկատի ունենք
          բոլոր նրանց, ում համար կարևոր է ոչ ֆորմալ կրթությամբ անընդհատական,
          շարունակական ինքնակրթությունը, որին կարող են մասնակցել նույն այդ
          ուսանողների ու աշակերտների ծնողները, ինքնակրթությամբ հետաքրքրվողները,
          նրանք ովքեր ցանկություն կամ կարիք ունեն լրացնելու, վերաթարմացնելու
          սեփական գիտելիքներն ու հիշողությունը, որոնք կազմում են ազգաբնակչության
          հսկայական զանգված, որովհետև թվային հարթակը հնարվորություն է տալիս, այդ
          դասերը լսել ու դիտել տանը, ճանապարհին, աշխատավայրում, յուրաքանչյուր
          իրավիճակում՝ երեխայի հետ դաս պատրաստելիս, կենցաղային-տնային գործերն
          անելիս, անգամ դպրոց գնալիս և այլն։ Այսինքն՝ դպրոցը և կրթությունը ոչ թե
          քեզնից կտրված ինչ որ հեռավոր շենք է ու կառույց, կամ առկա միայն
          լսարանում ու գրատախտակին, այլ հենց քո հետ ու քո կողքին, քո տանն ու քո
          առօրյայում։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Այսինքն՝ <strong className="text-[#493ED3]">«Ազգային Դպրոցը»</strong>{" "}
          ազգային կրթություն ու դաստիարակություն առաջարկող ու կազմակերպող գործիք
          ու միջոց է, որը մեր բոլորի համատեղ ջանքերով ու ստեղծարար
          համագործակցությամբ, կարող է դառնալ մեր ազգի, հայրենիքի ու
          պետականության դեմ մղվող անհաշտ պայքարում հաղթանակ տանելու կարևորագույն
          երաշխիքն ու գրավականը։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          Վերջին հաշվով,{" "}
          <strong className="text-[#493ED3]">«Ազգային Դպրոցը»</strong> գործիք է,
          որը կարող է կիրառել յուրաքանչյուր հայ մարդ և հայկական կրթօջախ իր, իր
          երեխաների ու սաների հայեցի դաստիարակության և կրթության սուրբ ու
          նվիրական գործում։ Այսինքն՝ Ազգային Քաղաքակրթական հիմքի վրա ձևավորվող
          Ազգային Կրթակարգը դառնում է աշխարհի յուրաքանչյուր ծայրում հասանելի և,
          հատուկ շեշտենք, հասանելի է անվճար։
        </p>
        <p className="my-4 text-[#493ED3] font-noto-sans-armenian text-[18px] font-semibold leading-normal">
          Մեկ խոսքով և ըստ էության՝
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <strong className="text-[#493ED3]">«Ազգային Դպրոցը»</strong> իր{" "}
          <strong className="text-[#493ED3]">«Ազգային Կրթակարգով»</strong> հային
          Հայ պահող ու պաշտպանող նորօրյա Խաչ Պատերազմինն է, կենսասնուցող
          Կաթնաղբյուրն է, հաղթանակ պարգևող ազգազեն Թուր Կեծակին է, թռիչքաձև
          զարգացում ապահովող Քուռկիկ Ջալալին և Ազգային հավատամքային ու
          արժեհամակարգային Մարութա Սուրբ Աստվածածին տաճար տանող անշեղ ուղին է։
        </p>
      </div>
    </div>
  );
};

export default Mission;
